
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createLocation } from "../redux/actions/VisitLocationActions";

const CreateVisitLocation = () => {
  const [locationName, setLocationName] = useState("");

  const dispatch = useDispatch();
  const { creating, error } = useSelector((state) => state.VisitLocation);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!locationName) return;

    dispatch(createLocation(locationName));
    setLocationName("");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Visit Location</h1>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            Error: {typeof error === "string" ? error : error?.message || "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Location Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Location Name</label>
            <input
              type="text"
              placeholder="Enter location name"
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-cyan-500"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-semibold rounded-md transition ${
              creating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Creating..." : "Create Location"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateVisitLocation;
